<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.status" @tab-click="handleFilter">
          <el-tab-pane label="所有店员" name="-1" />
          <el-tab-pane label="已禁用的店员" name="0" />
          <el-tab-pane label="已允许的店员" name="1" />
        </el-tabs>

        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.shopName" class="filter-item" placeholder="商家名称" />
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.mobile" class="filter-item" placeholder="员工手机号" />
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" type="danger" icon="el-icon-edit" @click="handleCreate">增加店员</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="员工名称" prop="userName" class-name="name-col" />
        <el-table-column label="昵称" prop="nickName" class-name="name-col" />
        <el-table-column label="手机号" prop="mobile" class-name="name-col" />
        <el-table-column label="启用状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>"
        </el-table-column>
        <el-table-column label="是否后台管理员" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.isAdmin | checkType" effect="dark" size="medium">{{ row.isAdmin | checkText }}</el-tag>
          </template>
        </el-table-column>
        <template v-if="queryParams.shopId">
          <el-table-column label="所属商家" prop="shortName" />
          <el-table-column label="是否店长" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.isManager | checkType" effect="dark" size="medium">{{ row.isManager | checkText }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否有核销权限" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="(row.isAdmin || row.isManager || row.verifyStatus) | checkType" effect="plain" size="medium">{{ (row.isAdmin || row.isManager || row.verifyStatus) | checkText }}</el-tag>
            </template>
          </el-table-column>
        </template>

        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{row}">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native.stop="handleEdit(row)"><i class="el-icon-edit" /> 编辑</el-dropdown-item>
                <el-dropdown-item divided @click.native.stop="handleDelete(row)"><i class="el-icon-delete" /> 删除</el-dropdown-item>
                <el-dropdown-item divided @click.native.stop="handleReset(row)"><i class="el-icon-refresh" /> 重置密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <employee-detail v-if="detailDialog" :show.sync="detailDialog" :employee-id="employeeId" :shop-info="storeInfo" :stores="storeList" @submit="handleSave" />
  </div>
</template>

<script>
import { getEmployeeList, getStoreDetail, getStoreList, removeEmployee, updateEmployee, resetEmployeePassword } from '@/api/store'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { mapState } from 'vuex'

export default {
  name: 'StoreEmployee',
  components: {
    Pagination: () => import('@/components/Pagination'),
    EmployeeDetail: () => import('./detail')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  filters: {
    checkType(index) {
      const tag = ['info', 'success']
      return tag[index]
    },
    checkText(index) {
      return !index ? '否' : '是'
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      employeeId: '',
      detailDialog: false,
      queryParams: {
        shopName: '',
        shopId: '',
        mobile: '',
        status: '-1',
        isAdmin: '',
        isManager: '',
        isVerify: '',
        page: 1,
        limit: 20
      },
      storeList: [],
      storeInfo: {}
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  created() {
    this.queryParams.shopId = this.$route.query.shopId || ''
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = Object.assign({}, this.queryParams, { status: '' })
      const arrPromise = [getStoreList({ status: 1, state: 1 }), getEmployeeList(params)]
      if (this.queryParams.shopId) arrPromise.push(getStoreDetail(this.queryParams.shopId))

      Promise.all(arrPromise).then(response => {
        this.total = response[1].total
        this.$util.delay().then(() => {
          this.list = response[1].records
          this.storeList = response[0]
          this.loading = false
          if (response.length === 3) {
            this.storeInfo = {
              id: '',
              employeeId: '',
              isManager: 0,
              verifyStatus: 1,
              shopId: response[2].id,
              shopName: response[2].shopName
            }
          }
        })
      }).catch(() => {
        this.loading = false
      })
    },
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.queryParams, {
        status: this.queryParams.status === '-1' ? '' : this.queryParams.status
      })
      getEmployeeList(params).then(response => {
        this.total = response.total
        this.$util.delay().then(() => {
          this.list = response.records
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    handleCreate() {
      this.loading = true
      this.employeeId = ''
      this.$util.delay().then(() => {
        this.detailDialog = true
        this.loading = false
      })
    },
    handleUpdate(row) {
      updateEmployee(row).then(response => {
        if (response) this.$message.success('更新店员状态成功')
      }).catch(() => {
        row.status = !row.status ? 0 : 1
      })
    },
    handleEdit(row) {
      this.loading = true
      this.employeeId = row.id
      this.$util.delay().then(() => {
        this.detailDialog = true
        this.loading = false
      })
    },
    handleDelete(row) {
      this.$confirm(`你确定要删除店员【${row.userName}】吗？`, '温馨提示', { type: 'warning' }).then(() => {
        removeEmployee(row.id).then(response => {
          if (response) {
            this.$message.success('删除店员成功')
            this.fetchData()
          }
        })
      }).catch(() => {})
    },
    handleReset(row) {
      this.$confirm('您确认要重置该店员的登录密码吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetEmployeePassword(row).then(response => {
          this.$message.success(response)
        })
      }).catch(() => {})
    },
    handleSave() {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
